import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import Card, { CardBody, CardHeader, CardLabel, CardTitle, CardFooter, CardActions } from '../../../components/bootstrap/Card';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Label from '../../../components/bootstrap/forms/Label';
import Input from '../../../components/bootstrap/forms/Input';
import Button from '../../../components/bootstrap/Button';
import api from '../../../services/api';
import showNotification from '../../../components/extras/showNotification';
import BillingValuesDB from '../../../database/wrappers/billingValues';
import masks, { unmask } from '../../../helpers/utils/masks';
import { inputMoneyMask } from '../../../utils/input';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';

const BillingValue = () => {
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            system: '',
            pos: '',
            posDelivery: '',
            printer: '',
            totem: '',
            tablet: ''
        },
        onSubmit: async (values) => {
            try {
                setLoading(true);
                const payload = {
                    system: Number(unmask(values.system)),
                    pos: Number(unmask(values.pos)),
                    posDelivery: Number(unmask(values.posDelivery)),
                    printer: Number(unmask(values.printer)),
                    totem: Number(unmask(values.totem)),
                    tablet: Number(unmask(values.tablet))
                };
                await api.put('billing/values', payload);
                showNotification('Sucesso', 'Valores atualizados com sucesso', 'success');
            } catch (error) {
                showNotification('Erro', 'Erro ao salvar valores', 'danger');
            } finally {
                setLoading(false);
            }
        }
    });

    const fetchValues = async () => {
        try {
            setLoading(true);
            const db = new BillingValuesDB();
            const data = await db.get('BillingValues');
            if (data) {
                formik.setValues({
                    system: masks.money(String(data.system)),
                    pos: masks.money(String(data.pos)),
                    posDelivery: masks.money(String(data.posDelivery)),
                    printer: masks.money(String(data.printer)),
                    totem: masks.money(String(data.totem)),
                    tablet: masks.money(String(data.tablet))
                });
            }
        } catch (error) {
            console.error(error);
            showNotification('Erro', 'Erro ao buscar valores', 'danger');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchValues();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeNumbers = (e) => inputMoneyMask(formik, e);

    const renderInput = (label, field) => (
        <FormGroup className='row mb-3' label={label} labelClassName='col-md-3' isColForLabel>
            <div className='col-md-3'>
                <Input
                    id={field}
                    size='sm'
                    onChange={onChangeNumbers}
                    onBlur={formik.handleBlur}
                    value={formik.values[field]}
                    isValid={formik.isValid}
                    isTouched={formik.touched[field]}
                    invalidFeedback={formik.errors[field]}
                    placeholder='0,00'
                />
            </div>
        </FormGroup>
    );

    return (
        <PageWrapper title="Valores de Assinatura">
            <Page container="fluid">
                <div className='row'>
                    <div className='col-12'>
                        <Card>
                            <CardHeader>
                                <CardLabel icon='Paid' iconColor='dark'>
                                    <CardTitle>Valores de Assinatura</CardTitle>
                                </CardLabel>
                            </CardHeader>
                            <CardBody>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        {renderInput('Sistema', 'system')}
                                        {renderInput('POS', 'pos')}
                                        {renderInput('POS Delivery', 'posDelivery')}
                                    </div>
                                    <div className='col-md-6'>
                                        {renderInput('Impressora', 'printer')}
                                        {renderInput('Totem', 'totem')}
                                        {renderInput('Tablet', 'tablet')}
                                    </div>
                                </div>
                            </CardBody>
                            <CardFooter>
                                <CardActions>
                                    <Button
                                        color='danger'
                                        shadow="sm"
                                        hoverShadow="sm"
                                        size="sm"
                                        icon="cancel"
                                        rounded={1}
                                        onClick={() => fetchValues()}
                                        disabled={loading}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        color='primary'
                                        onClick={formik.handleSubmit}
                                        disabled={loading}
                                        rounded={1}
                                        hoverShadow="sm"
                                        shadow="sm"
                                        icon="save"
                                        size="sm"
                                    >
                                        Confirmar
                                    </Button>
                                </CardActions>
                            </CardFooter>
                        </Card>
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default BillingValue;
